'use client';

import { useTranslations } from 'next-intl';
import { EarnCreditsIcon } from '../assets/EarnCreditsIcon';

interface EarnCreditsBtnProps {
  handleOpenEarnCreditsDialog: () => void;
}

export const EarnCreditsBtn = ({ handleOpenEarnCreditsDialog }: EarnCreditsBtnProps) => {
  const t = useTranslations();
  return (
    <button
      type="button"
      className="flex h-[34px] cursor-pointer items-center justify-center gap-1 rounded-8 border border-system-white08 bg-system-white04 px-3 font-normal transition-colors"
      onClick={() => {
        handleOpenEarnCreditsDialog();
      }}
    >
      <EarnCreditsIcon className="size-[18px] shrink-0" />
      <span className="text-sm text-system-white">{t('freeCreditsDialog.earnCredits')}</span>
    </button>
  );
};
